import * as React from 'react';
import { SVGProps } from 'react';

const IconPriceLabelStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path d="M8.025 2.981a.991.991 0 1 1 0 1.982.991.991 0 0 1 0-1.982Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1a1 1 0 0 1 1 .999v3.54a1 1 0 0 1-.294.707l-4.463 4.457-.076.069c-.389.317-.962.298-1.33-.06L1.305 7.279l-.071-.074a1 1 0 0 1-.017-1.263l.068-.077 4.461-4.563c.165-.168.383-.273.616-.296L6.463 1H10ZM6.461 2l-4.46 4.563 3.533 3.434L10 5.54V2L6.462 2Z"
    />
  </svg>
);
export default IconPriceLabelStrokedSizeXs;
